import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  // BehaviorSubject to store form submit state
  private formSubmitState = new BehaviorSubject<boolean>(false);
  //private clearPrevData = new BehaviorSubject<boolean>(false);
  private resetForm = new BehaviorSubject<boolean>(false);

  constructor() { }

  setFormSubmitState(state: boolean) {
    this.formSubmitState.next(state);
  }

  getFormSubmitState() {
    return this.formSubmitState.asObservable();
  }

  setResetForm(state: boolean) {
    this.resetForm.next(state);
  }

  getResetForm() {
    return this.resetForm.asObservable();
  }

  // setClearPrevData(state: boolean) {
  //   this.clearPrevData.next(state);
  // }

  // getClearPrevData() {
  //   return this.clearPrevData.asObservable();
  // }
}
